import { Box, Modal, Typography } from "@mui/material";
import React from "react";
import LogoIcon from "../../../../media/images/icons/logo.svg";
interface Props {
  open: boolean;
  handleClose: () => void;
}

const style = {
  position: "absolute" as "absolute",
  display: "flex",
  flexDirection: "column",
  top: "50%",
  left: "50%",
  flex: "1",
  transform: "translate(-50%, -50%)",
  maxWidth: 400,
  minWidth: 350,
  height: "300px",
  border: "2px solid #000",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "15px",
  p: 2,
};

export default function RulesModal({ open, handleClose }: Props) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiBox-root": {
          border: "none",
        },
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        direction: "rtl",
      }}
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          <img src={LogoIcon} alt="" />
          <Box>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
                color: "primary.main",
              }}
            >
              قوانین و مقررات بازارگاه کارن ترابرنت
            </Typography>
            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: "500",
              }}
            >
              آخرین بروزرسانی: دهم اسفند1402
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            flex: "1",
            backgroundColor: "info.light",
            borderRadius: "10px",
            overflow: "auto",
            mt: 3,
            pt: 2,
            paddingX: "4px",
          }}
        >
          <Typography
            sx={{
              fontWeight: "500",
            }}
          >
            1. استفاده از سرویس:
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
            }}
          >
            {" "}
            الزامی است که از این سرویس به نحوی استفاده کنید که با قوانین و
            مقررات مربوط به حقوق دیگران هماهنگ باشد. همچنین تضمین می‌شود که
            استفاده شما مسئولانه و مجاز باشد.
          </Typography>
          <Typography
            sx={{
              fontWeight: "500",
            }}
          >
            2. حقوق مالکیت و تکنولوژی:{" "}
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
            }}
          >
            {" "}
            تمامی حقوق مالکیت فکری و تکنولوژی مرتبط با این سرویس به مالک و
            توسعه‌دهنده تعلق دارد. هرگونه استفاده غیرمجاز از منابع و اطلاعات
            تکنولوژیکی ممکن است تحت پیگرد قانونی قرار گیرد.
          </Typography>
          <Typography
            sx={{
              fontWeight: "500",
            }}
          >
            3. حریم خصوصی:{" "}
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
            }}
          >
            {" "}
            ما به حریم خصوصی شما ارزش می‌دهیم و از اطلاعات شخصی شما با احترام
            برخورد می‌کنیم. لطفاً سیاست حریم خصوصی ما را برای درک بهتر از چگونگی
            استفاده و حفاظت اطلاعات مطالعه کنید.
          </Typography>
          <Typography
            sx={{
              fontWeight: "500",
            }}
          >
            3. حریم خصوصی:{" "}
          </Typography>
          <Typography
            sx={{
              fontSize: "14px",
            }}
          >
            {" "}
            ما به حریم خصوصی شما ارزش می‌دهیم و از اطلاعات شخصی شما با احترام
            برخورد می‌کنیم. لطفاً سیاست حریم خصوصی ما را برای درک بهتر از چگونگی
            استفاده و حفاظت اطلاعات مطالعه کنید.
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
}
